$(document).ready(function() {
    function t() {
       
        $.ajax({
            url: "/cart?view=slidecart",
            dataType: "HTML",
            method: "GET",
            success: function(t) {
                t = $(t).find(".js-cart-update").html(), 
                $(".js-cart-update").html(t), t = $("html, body"), jQuery.getJSON("/cart.js", function(t) {
                    $(".cart-link__bubble").text(t.item_count);
                    if(t.item_count == 0){
                        $('.drawr_cart_note').val('');
                       
                        //jQuery.post(window.Shopify.routes.root + 'cart/update.js', "");
                      
                    }
                    
                }), t.stop().animate({
                    scrollTop: 0
                }, 200, function() {
                  
                    $(".cart-link").trigger("click")
                })
            }
        })
    }

    function e(e, n) {
        //
        $.ajax({
            url: "/cart/add.js",
            method: "POST",
            dataType: "JSON",
            data: {
                quantity: n,
                id: e
            },
            success: function(e) {
                t()
            }
        })
    }

    function n(e, n) {
        var c = {};
        c[e] = n;
        
         $.ajax({
            url: "/cart/update.js",
            method: "POST",
            dataType: "JSON",
            data: {
                updates: c
            },
            success: function(e) {
                
                console.log(e), t()
                var cartNote = $('.drawr_cart_note').val();
                var finalNote = 'note=' + cartNote;
                
                
                jQuery.post(window.Shopify.routes.root + 'cart/update.js', finalNote);
                // $('.drawr_cart_note').val(cartNote);
            },
            error: function(error) {
                console.log(error)
            }
        })
    }
    $(document).on("change", ".product-single__form-atc .product-variant input[type='radio']", function(t) {
        var e = $(t.target).parents("form.product-single__form-atc").eq(0),
            n = e.find("input[type='radio']:checked").val();
        e.find("select[name='id']").find("option").each(function(t, c) {
            $(c).removeAttr("selected", ""), -1 !== $(c).text().indexOf(n) && (console.log($(c)), $(c).attr("selected", "selected"), e.find("select[name='id']").trigger("change"))
        })
    }), $(document).on("change", ".product-single__form-atc .product_color select", function(t) {
        var e = "";
        $(".product_color").each(function() {
            $(this).find("select[class='option_select']").each(function() {
                $(this).attr("id"), "" != e && (e += " / "), e += $("#${each_id}").find(":selected").val()
            }), $("#VariantSelect option").removeAttr("selected"), $('#VariantSelect option[value="${variant}"]').prop("selected", !0)
        }), $("#VariantSelect").trigger("change")
    }), $(document).on("click", ".product-single__form-atc .add-to-cart", function(t) {
        t.preventDefault(), t = t.target, t = $(t).parents("form.product-single__form-atc").eq(0), e($(t).find('[name="id"]').val(), 1)
    }), $(document).on("click", ".cart-product-quantity .qty-input .more-js", function(t) {
        t.preventDefault(), n($(this).parent().find("input").attr("data-id"), parseInt($(this).parent().find("input").val()) + 1)
    }), $(document).on("click", ".cart-product-quantity .qty-input .less-js", function(t) {
       
        t.preventDefault(), n($(this).parent().find("input").attr("data-id"), parseInt($(this).parent().find("input").val()) - 1)
        
        
    }), $(document).on("click", ".cart-product-price-right a", function(t) {
        t.preventDefault(), n($(this).parents(".cart-product-item-text").find(".cart-product-quantity input").attr("data-id"), 0)
    }), $(document).on("click", ".slider-add-to-cart", function(t) {
        t.preventDefault(), e($(this).attr("data-id"), 1)
    }), $(document).on("click", ".button--tertiary", function(t) {
        location.reload()
    })
});

$(document).on('change', '.variant-input [type="radio"]', function(e) {
  console.log("1")
    e.preventDefault();

    var currentElement = $(this).val();
    var didFind = false;
    var optionsArray = new Array();

    $(".variant-input input[type=radio]:checked").each(function() {
        optionsArray.push($(this).val());

        $('.colorlabel').text($(this).val());
    });
     
    var variantsOption = optionsArray.join(" / ");
    console.log( variantsOption);
    $("#product_var option").each(function() {
        if ($(this).text() == variantsOption) {
      
            $(this).prop("selected", true);
            if ($(this).attr('data-available') == "true") {
           
                didFind = true;
                let cpPrice = $(this).attr("data-compareat-price");
                let price = $(this).attr("data-price");
               // $(".js-was-price").text(cpPrice);
                //$(".js-now-price>b").text(price);
            } else {
                //alert("Sorry, that option is not available currently!");
                return false;
            }
        }

    });
      if (didFind == false) {
        $(".product-form__submit").addClass("pro-js-disabled");
        $(".product-form__submit").addClass("disabled");
        $(".product-form__submit").addClass("btntransparent");
        $(".product-form__submit").text("Sold out"); 
        
    } else {
      console.log(true);
        $(".product-form__submit").removeClass("pro-js-disabled");
        $(".product-form__submit").removeClass("disabled");
        $(".product-form__submit").removeAttr("disabled");
        $(".product-form__submit").text("Add to cart");
       

      
    }
  
    var imagePath1 = $("#product_var option:selected").attr("data-image");
    console.log(imagePath1);
   
    console.log(imagePath1);
var variantName = $("#product_var option:selected").text();
$(".variant-label-option-value").text(variantName);

$('.pdp-slider-nav li').each(function() {
    
    var image_index = $(this).attr('data-slick-index');

    let slick_image = $(this).find('img').attr('src');
   
     slick_image = slick_image.split('&width=');
    console.log(slick_image);
    if (imagePath1 == slick_image[0]) {
            console.log(imagePath1);
           
          
        $('.pdp-slider-for').slick('slickGoTo', parseInt(image_index));
       
    }
});
  


});

    

    
    
        $(document).on("change", ".js-main-select select", function(t) {
          console.log("2")
        t.preventDefault();
        let parent = $(t.target).parents(`.add_items_block`);
        let test = parent.find('#js-product-dropdown');
        console.log(test)
        
        var currentElement = $(this).val();
       let didFindTheVariant = false;
        var didFind = false;
        var optionsArray = new Array();
    
        parent.find($(".js-main-select select")).each(function () { 
          var currentSelectElement = $(this);
          var selectedValue = currentSelectElement.find("option:selected").val();
          optionsArray.push($(this).val()); 
        });
    
        var variantsOption = optionsArray.join(" / ");
        $(this).prop("selected", false);
        parent.find("#js-product-dropdown option").each(function () {
          var currentOption = $(this);
          console.log('main', variantsOption);
          console.log('hide', currentOption.text());
          
          if (variantsOption == currentOption.text()) {
            $(this).prop("selected", true);
            if (currentOption.attr('data-available') == "true") {
              didFind = true;
             didFindTheVariant = true;
              var test1 = parent.find("#js-product-dropdown option:selected").attr("data-price");
               
              parent.find('.js_rec_price').html(test1);
            } else {
              alert("Sorry, that option is not available currently!");
              return false;
            }
          }
        });
    
        if (didFind == false) {
            parent.find(".rec_btn_atc").html("Sold Out");
            parent.find(".rec_btn_atc").css("opacity", "0.5");
            parent.find(".rec_btn_atc").css("pointer-events", "none");
        } else {
            parent.find(".rec_btn_atc").html('Add <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.70988 1.00977V13.7498" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round" /><path d="M1.33984 7.37883H14.0798" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round" /></svg>');
            parent.find(".rarec_btn_atc").removeClass("disabled");;
            parent.find(".rec_btn_atc").css("opacity", "1");
            parent.find(".rec_btn_atc").css("pointer-events", "all");
        }
        if( didFindTheVariant == false ) {
            $(".product-page-atc").html("Not Available");
            parent.find(".rec_btn_atc").html("Not Available");
            parent.find(".rec_btn_atc").css("opacity", "0.5");
            parent.find(".rec_btn_atc").css("pointer-events", "none");
          }else{
            parent.find(".rec_btn_atc").html('Add <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.70988 1.00977V13.7498" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round" /><path d="M1.33984 7.37883H14.0798" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round" /></svg>');
            parent.find(".rarec_btn_atc").removeClass("disabled");;
            parent.find(".rec_btn_atc").css("opacity", "1");
            parent.find(".rec_btn_atc").css("pointer-events", "all");
          }
      });


   
 

   
   